<template>
  <el-container class="layout">
    <el-aside width="200px" class="aside">
      <div class="logo">追溯管理</div>
      <el-menu
        :default-active="activeMenu"
        background-color="#001529"
        text-color="#fff"
        active-text-color="#409EFF"
        router
      >
        <el-menu-item v-if="isAdmin" index="/users">
          <i class="el-icon-user"></i>
          <span>用户管理</span>
        </el-menu-item>
        <el-menu-item index="/categories">
          <i class="el-icon-menu"></i>
          <span>分类管理</span>
        </el-menu-item>
        <el-menu-item index="/products">
          <i class="el-icon-goods"></i>
          <span>产品管理</span>
        </el-menu-item>
        <el-menu-item index="/profile">
          <i class="el-icon-setting"></i>
          <span>个人中心</span>
        </el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header class="header">
        <span>{{ user.nickName || user.userName }}</span>
        <el-button type="text" @click="handleLogout">退出</el-button>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { logout } from '../api/auth'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'Layout',
  computed: {
    ...mapState(['user']),
    ...mapGetters(['isAdmin']),
    activeMenu() {
      return this.$route.path
    }
  },
  methods: {
    async handleLogout() {
      try {
        await logout()
      } catch (e) {
        // ignore
      }
      this.$store.dispatch('logout')
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.layout {
  height: 100vh;
}
.aside {
  background: #001529;
}
.logo {
  color: #fff;
  text-align: center;
  line-height: 60px;
  font-size: 18px;
  font-weight: bold;
}
.header {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  background: #fff;
  border-bottom: 1px solid #e8edf2;
  color: #1a3353;
  font-size: 14px;
}
</style>

<style>
.layout .el-main {
  background: #f0f2f5;
  padding: 24px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: calc(100vh - 60px);
  box-sizing: border-box;
}
</style>
